/* Cardify custom winkelmandje — 1-op-1 nabouw van de DC-mand (localStorage "cf-mand"), geen Dawn-cart. */
(function () {
  var KEY = "cf-mand";
  function laad() { try { var m = JSON.parse(localStorage.getItem(KEY) || "[]"); return Array.isArray(m) ? m : []; } catch (e) { return []; } }
  function bewaar(m) { try { localStorage.setItem(KEY, JSON.stringify(m)); } catch (e) {} }
  function fmt(cent) { return "€ " + (cent / 100).toFixed(2).replace(".", ","); }

  var mand = laad();

  function badges() {
    var n = mand.reduce(function (s, r) { return s + r.qty; }, 0);
    document.querySelectorAll("[data-mand-aantal]").forEach(function (el) { el.textContent = n; });
    return n;
  }
  function pulsBadge() {
    document.querySelectorAll("[data-mand-badge]").forEach(function (el) {
      el.style.animation = "none";
      requestAnimationFrame(function () { el.style.animation = "cf-mandtik .5s cubic-bezier(.16,1,.3,1)"; });
    });
  }
  function vind(id) { return mand.find(function (r) { return r.id === id; }); }

  /**
   * Productkaarten (25 okt 2026): staat een product al in de mand, dan wordt de knop op de
   * kaart een teller (− aantal +), zodat je ziet wat je al hebt. De teller gebruikt de
   * gewone data-cf-min/plus-knoppen hieronder; deze functie zet alleen de zichtbaarheid.
   */
  function kaartTellers() {
    document.querySelectorAll("[data-cf-teller]").forEach(function (el) {
      var r = vind(el.getAttribute("data-cf-teller"));
      var knop = el.querySelector("[data-cf-add]"), teller = el.querySelector(".cf-kaart-teller");
      if (!knop || !teller) return;
      knop.hidden = !!r; teller.hidden = !r;
      if (r) teller.querySelector("[data-cf-teller-aantal]").textContent = r.qty;
    });
  }

  // stil = geen "toegevoegd"-venster, voor knoppen die al in de mand staan (de mysterie-pack-upsell).
  function add(item, qty, stil) {
    qty = qty || 1;
    var r = vind(item.id);
    if (r) { r.qty += qty; if (item.variant) r.variant = item.variant; }
    else mand.push(Object.assign({ qty: qty }, item));
    bewaar(mand); badges(); pulsBadge();
    if (!stil) toonSheet(item);
    else { var sh = document.getElementById("cf-sheet"); if (sh && sh.style.display === "block") renderPack(); }
    renderMandPagina();
    kaartTellers();
  }
  function zetQty(id, qty) {
    var r = vind(id); if (!r) return;
    if (qty <= 0) mand = mand.filter(function (x) { return x.id !== id; });
    else r.qty = qty;
    bewaar(mand); badges(); renderMandPagina(); kaartTellers();
    var sh = document.getElementById("cf-sheet-aantal");
    if (sh && sh.parentNode.querySelector("[data-cf-min]").getAttribute("data-id") === id) {
      if (qty <= 0) sluitSheet(); else zetSheetAantal(id);
    }
  }
  function verwijder(id) { zetQty(id, 0); }
  function totaalCent() { return mand.reduce(function (s, r) { return s + r.qty * r.prijsCent; }, 0); }

  function toonSheet(item) {
    var sheet = document.getElementById("cf-sheet"); if (!sheet) return;
    document.getElementById("cf-sheet-img").src = item.img;
    document.getElementById("cf-sheet-naam").textContent = item.naam;
    document.getElementById("cf-sheet-set").textContent = item.set || "";
    zetSheetAantal(item.id);
    var sugWrap = document.getElementById("cf-sheet-sug");
    if (sugWrap && window.__CF_PRODUCTS__) {
      var opties = window.__CF_PRODUCTS__.filter(function (p) { return p.id !== item.id && !p.uit; });
      // Bij een goedkoop artikel (een losse kaart) geen doos van vijfhonderd euro aanraden: dan
      // alleen wat tot € 50 kost, als dat er is.
      if (item.prijsCent < 1000) { var klein = opties.filter(function (p) { return p.prijsCent <= 5000; }); if (klein.length) opties = klein; }
      opties.sort(function () { return Math.random() - 0.5; });
      sugWrap.innerHTML = opties.slice(0, 3).map(function (p) {
        return '<div style="display:flex;align-items:center;gap:13px;background:#FFFFFF;border:1px solid #E4E1D6;border-radius:14px;padding:12px">' +
          '<a href="' + p.url + '" style="width:54px;height:54px;flex:none;border-radius:10px;background:linear-gradient(160deg,#FCFCFA,#F3F3ED);display:flex;align-items:center;justify-content:center;padding:6px;overflow:hidden"><img src="' + p.img + '" alt="" style="max-width:100%;max-height:100%;object-fit:contain"></a>' +
          '<div style="flex:1;min-width:0"><a href="' + p.url + '" style="display:block;font-family:\'Archivo\',sans-serif;font-weight:700;font-size:14px;line-height:1.25">' + p.naam + '</a><p style="margin:3px 0 0;font-size:13px;font-weight:700;color:#6B6B62">' + fmt(p.prijsCent) + '</p></div>' +
          '<button data-cf-add data-id="' + p.id + '" data-variant="' + (p.variant || '') + '" data-naam="' + p.naam + '" data-img="' + p.img + '" data-set="' + (p.set || "") + '" data-prijs="' + p.prijsCent + '" style="border:none;border-radius:10px;padding:11px 14px;min-height:44px;min-width:110px;background:#CFF84A;color:#111110;font-weight:700;font-size:12.5px;cursor:pointer;flex:none" data-nl="Toevoegen" data-en="Add">Toevoegen</button>' +
          '</div>';
      }).join("");
    }
    var sugKop = document.getElementById("cf-sheet-sugkop");
    if (sugKop && sugWrap) sugKop.style.display = sugWrap.children.length ? "" : "none";
    renderPack(item);
    document.getElementById("cf-sheet-overlay").style.display = "block";
    sheet.style.display = "block";
  }
  /**
   * Mysterie pack in het toegevoegd-venster (27 okt 2026). De drie formaten als knoppen; een
   * klik voegt het pack stil toe (geen nieuw venster over dit venster heen) en de knop toont dan
   * dat het in de mand ligt. (De regel over gratis verzending is sinds 30 okt 2026 weg: altijd
   * verzendkosten.) Niet tonen bij het pack zelf of als er al
   * een pack in de mand ligt. Gegevens uit window.__CF_PACK__ (snippets/cardify-products-json).
   */
  var laatsteItem = null;
  function renderPack(item) {
    var wrap = document.getElementById("cf-sheet-pack"); if (!wrap) return;
    if (item) laatsteItem = item;
    var pack = window.__CF_PACK__;
    var ids = pack ? pack.formaten.map(function (f) { return f.id; }) : [];
    var isPack = laatsteItem && ids.indexOf(String(laatsteItem.id)) > -1;
    var heeftPack = mand.some(function (r) { return ids.indexOf(String(r.id)) > -1; });
    if (!pack || !pack.formaten.length || isPack || (heeftPack && item)) { wrap.innerHTML = ""; return; }
    var en = (window.CardifyI18n && window.CardifyI18n.taal) === "en";
    wrap.innerHTML = '<div class="cf-sheetpack">' +
      '<div class="cf-sheetpack-kop"><img src="' + pack.img + '" alt=""><div><b>' + (en ? "Add a mystery pack" : "Doe er een mysterie pack bij") + '</b><span>' +
        (en ? "Single cards from our own stock, picked as a surprise. Shipped with your order." : "Losse kaarten uit onze eigen voorraad, verrassend gekozen. We sturen het mee met je bestelling.") + '</span></div></div>' +
      '<div class="cf-sheetpack-keuzes">' + pack.formaten.map(function (f) {
        var inMand = !!vind(f.id);
        return '<button type="button" data-cf-add data-cf-stil data-id="' + f.id + '" data-variant="' + f.id + '" data-naam="Mysterie pack ' + f.naam.toLowerCase() + ' (' + f.aantal + ')" data-img="' + f.img + '" data-set="" data-prijs="' + f.prijsCent + '"' + (inMand ? " data-in-mand" : "") + '>' +
          (inMand ? "✓ " : "") + f.naam + '<small>' + f.aantal + ' · ' + fmt(f.prijsCent) + '</small></button>';
      }).join("") + '</div>' +
      '</div>';
  }

  // Teller in het "toegevoegd"-venster: zelfde data-cf-min/plus als in de mand, met het id van dit product.
  function zetSheetAantal(id) {
    var r = vind(id), el = document.getElementById("cf-sheet-aantal"); if (!el) return;
    el.parentNode.querySelectorAll("[data-cf-min],[data-cf-plus]").forEach(function (k) { k.setAttribute("data-id", id); });
    el.textContent = r ? r.qty : 0;
  }
  function sluitSheet() {
    var s = document.getElementById("cf-sheet"), o = document.getElementById("cf-sheet-overlay");
    if (s) s.style.display = "none"; if (o) o.style.display = "none";
  }

  /**
   * Een mandregel. De opmaak staat bewust in klassen en niet meer in style-
   * attributen: op een telefoon moet deze rij over twee regels breken, en een
   * media query komt niet bij een inline stijl. Zie .cf-mandrij in theme.liquid.
   */
  function renderMandPagina() {
    var wrap = document.getElementById("cf-mand-regels"); if (!wrap) return;
    if (!mand.length) {
      wrap.innerHTML = '<p style="padding:30px;text-align:center;color:#6B6B62" data-nl="Je winkelmand is leeg." data-en="Your cart is empty.">Je winkelmand is leeg.</p>';
    } else {
      wrap.innerHTML = mand.map(function (r) {
        return '<div data-mandrij class="cf-mandrij">' +
          '<span class="cf-mandfoto"><img src="' + r.img + '" alt="" loading="lazy"></span>' +
          '<div class="cf-mandtitel"><p class="cf-mandnaam">' + r.naam + '</p><p class="cf-mandset">' + (r.set || "") + '</p></div>' +
          '<button data-cf-weg data-id="' + r.id + '" class="cf-mandweg" aria-label="Verwijderen" data-attr-titel-nl="Uit je mand halen" data-attr-titel-en="Remove from cart">✕</button>' +
          '<div class="cf-mandacties">' +
            '<div data-mandknoppen class="cf-mandaantal">' +
              '<button data-cf-min data-id="' + r.id + '" aria-label="Eén minder">−</button>' +
              '<span>' + r.qty + '</span>' +
              '<button data-cf-plus data-id="' + r.id + '" aria-label="Eén meer">+</button>' +
            '</div>' +
            '<span data-mandtotaal class="cf-mandprijs">' + fmt(r.qty * r.prijsCent) + '</span>' +
          '</div>' +
          '</div>';
      }).join("");
    }
    var tot = document.getElementById("cf-mand-totaal"); if (tot) tot.textContent = fmt(totaalCent());
  }

  /**
   * Menu openen en sluiten. Zonder de scrollvergrendeling scrolt de pagina
   * onder het open menu gewoon door, en ben je bij het sluiten je plek kwijt.
   */
  function openMenu() {
    var d = document.getElementById("cf-drawer"), o = document.getElementById("cf-drawer-overlay");
    if (!d) return;
    d.style.display = "block";
    if (o) o.style.display = "block";
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    var eerste = d.querySelector("[data-drawer-sluit]");
    if (eerste && eerste.focus) eerste.focus();
  }
  function sluitMenu() {
    var d = document.getElementById("cf-drawer"), o = document.getElementById("cf-drawer-overlay");
    if (d) d.style.display = "none";
    if (o) o.style.display = "none";
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  }
  function menuOpen() {
    var d = document.getElementById("cf-drawer");
    return !!d && getComputedStyle(d).display !== "none";
  }

  document.addEventListener("click", function (e) {
    // Aantal-kiezer op de productpagina: − en + houden het veld binnen min en max.
    var aMin = e.target.closest("[data-cf-aantal-min]"), aPlus = e.target.closest("[data-cf-aantal-plus]");
    if (aMin || aPlus) {
      var veld = (aMin || aPlus).parentNode.querySelector("input");
      var n = (parseInt(veld.value, 10) || 1) + (aPlus ? 1 : -1);
      veld.value = Math.max(1, Math.min(parseInt(veld.max, 10) || 99, n));
      return;
    }
    var addBtn = e.target.closest("[data-cf-add]");
    if (addBtn) {
      var bron = addBtn.dataset.aantalBron && document.querySelector(addBtn.dataset.aantalBron + " input");
      var aantal = bron ? Math.max(1, Math.min(parseInt(bron.max, 10) || 99, parseInt(bron.value, 10) || 1)) : 1;
      add({ id: addBtn.dataset.id, variant: addBtn.dataset.variant, naam: addBtn.dataset.naam, img: addBtn.dataset.img, set: addBtn.dataset.set, prijsCent: parseInt(addBtn.dataset.prijs, 10) || 0 }, aantal, addBtn.hasAttribute("data-cf-stil"));
      if (bron) bron.value = 1;
      return;
    }
    var checkoutBtn = e.target.closest("[data-cf-checkout]");
    if (checkoutBtn) { e.preventDefault(); checkout(checkoutBtn); return;
    }
    if (e.target.closest("[data-cf-sheet-sluit]") || e.target.id === "cf-sheet-overlay") { sluitSheet(); return; }
    var min = e.target.closest("[data-cf-min]"); if (min) { var r = vind(min.dataset.id); zetQty(min.dataset.id, r ? r.qty - 1 : 0); return; }
    var plus = e.target.closest("[data-cf-plus]"); if (plus) { var r2 = vind(plus.dataset.id); zetQty(plus.dataset.id, (r2 ? r2.qty : 0) + 1); return; }
    var weg = e.target.closest("[data-cf-weg]"); if (weg) { verwijder(weg.dataset.id); return; }
    var burger = e.target.closest("[data-burger]"); if (burger) { openMenu(); return; }
    var drawerSluit = e.target.closest("[data-drawer-sluit]") || e.target.id === "cf-drawer-overlay";
    if (drawerSluit) { sluitMenu(); return; }
  });

  // Escape hoort net zo goed te sluiten als de kruisknop en de overlay.
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (menuOpen()) { sluitMenu(); return; }
    var s = document.getElementById("cf-sheet");
    if (s && getComputedStyle(s).display !== "none") sluitSheet();
  });

  /** Zet het custom mandje om in Shopify's echte cart en ga naar de checkout. */
  function checkoutFout(knop, tekst) {
    if (knop) { knop.disabled = false; knop.style.opacity = "1"; }
    var el = document.querySelector("[data-cf-checkout-fout]");
    if (el) { el.textContent = tekst; el.hidden = false; }
    else { window.alert(tekst); }
  }

  function checkout(knop) {
    var regels = mand.filter(function (r) { return r.variant; })
      .map(function (r) { return { id: Number(r.variant), quantity: r.qty }; });

    // Regels zonder variant kunnen niet naar Shopify. Dat mag niet stil gebeuren.
    if (regels.length !== mand.length) {
      var taal = (window.CardifyI18n && window.CardifyI18n.taal) || "nl";
      checkoutFout(knop, taal === "en"
        ? "One or more items can no longer be ordered. Please remove them and try again."
        : "Een of meer producten kunnen niet meer besteld worden. Haal ze uit je mand en probeer opnieuw.");
      if (!regels.length) return;
    }
    if (!regels.length) {
      window.location = "/pages/shop";
      return;
    }

    if (knop) { knop.disabled = true; knop.style.opacity = ".7"; }
    var el = document.querySelector("[data-cf-checkout-fout]");
    if (el) el.hidden = true;

    fetch("/cart/clear.js", { method: "POST" })
      .then(function (r) {
        if (!r.ok) throw new Error("clear " + r.status);
        return fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: regels })
        });
      })
      .then(function (r) {
        // Zonder deze controle ging je ook naar de kassa als het vullen mislukte,
        // bijvoorbeeld bij een uitverkocht product. Dan sta je daar met een lege mand.
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || "add " + r.status); });
        window.location = "/checkout";
      })
      .catch(function (e) {
        var taal = (window.CardifyI18n && window.CardifyI18n.taal) || "nl";
        checkoutFout(knop, taal === "en"
          ? "Could not start checkout: " + e.message + ". Please try again."
          : "Afrekenen lukte niet: " + e.message + ". Probeer het opnieuw.");
      });
  }

  window.CardifyCart = { add: add, zetQty: zetQty, verwijder: verwijder, sluitSheet: sluitSheet, sluitMenu: sluitMenu, checkout: checkout, mand: function () { return mand; }, kaartTellers: kaartTellers };
  document.addEventListener("DOMContentLoaded", function () { badges(); renderMandPagina(); kaartTellers(); });
  // Terug naar een pagina uit de browsercache: de mand kan intussen veranderd zijn.
  window.addEventListener("pageshow", function (e) { if (e.persisted) { mand = laad(); badges(); kaartTellers(); } });
})();